import DefaultNavbar from "components/DefaultNavbar";
import DefaultFooter from "components/DefaultFooter";

import HeaderSqMap from "../components/Maps/HeaderSqMap";

export default function SqMap(props) {
  return (
    <>
      <div className="relative w-full z-20 fixed">
        <DefaultNavbar />
      </div>
      <main>
        <HeaderSqMap
          // className="relative w-full z-20 fixed"
          positionGlobal1={props.positionGlobal}
          handleCallback1={props.handleCallback}
          shLink={props.shLink}
        />
        {/*<WorkingSection />*/}
        {/*<TeamSection />*/}
        {/*<ContactSection />*/}
      </main>
      <DefaultFooter />
    </>
  );
}
